import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { shareReplay, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { DictionaryService } from '../../data/dictionary.service';
import { DictionaryItem } from '../../models/DictionaryItem';

interface EmployerSelectionData {
  selectedEmployers?: number[];
}

@Component({
  selector: 'app-employer-selection-modal',
  templateUrl: './employer-selection-modal.component.html',
  styleUrls: ['./employer-selection-modal.component.scss'],
  standalone: false
})
export class EmployerSelectionModalComponent implements OnInit, OnDestroy {
  public listOfEmployers$: Observable<DictionaryItem[]>;
  public selectedEmployersControl = new FormControl<number[]>([]);

  private readonly unsubscribe$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<EmployerSelectionModalComponent>,
    private dictionaryService: DictionaryService,
    @Inject(MAT_DIALOG_DATA) public data: EmployerSelectionData
  ) { }

  ngOnInit(): void {
    this.listOfEmployers$ = this.dictionaryService.getEmployersList().pipe(shareReplay());

    if (this.data?.selectedEmployers) {
      this.selectedEmployersControl.setValue(this.data.selectedEmployers);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onGenerate(): void {
    const selectedEmployers = this.selectedEmployersControl.value || [];
    this.dialogRef.close(selectedEmployers);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  get canGenerate(): boolean {
    const selectedEmployers = this.selectedEmployersControl.value || [];
    return selectedEmployers.length > 0;
  }
}
